import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-10 md:py-24 px-5 md:px-6 bg-white text-center" data-id="element-52">
      <div className="max-w-2xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-4 md:space-y-6" data-id="element-54">
          <Button className="w-full md:w-auto text-lg md:text-xl py-4 md:py-5 px-6 md:px-10" data-id="element-55">
            QUIERO MIS RECETAS POR $14.99
          </Button>
          <p className="text-sm md:text-lg text-red-500 font-bold italic" data-id="element-56">
            ⏰ Oferta sensible al tiempo. El precio sube a{' '}
            <span className="underline decoration-2 underline-offset-2 not-italic" data-id="element-57">
              $49.99
            </span>{' '}
            sin previo aviso.
          </p>
        </motion.div>
      </div>
    </section>;
}